<template>
    <div off-canvas="slidebar-2 right reveal" class="slidebar">
        <h5 class="slidebar-title">系統切換</h5>
        <div class="accordion" id="accordionEx" role="tablist" aria-multiselectable="true">
            <div class="card" v-for="(title,index) in menuData" :key="index">
                <!-- Card header -->
                <div class="card-header" role="tab" :id="`heading${index}`">
                    <router-link :to="{ name: title.name? title.name : '' }" style="padding: 0;">
                        <a
                            class="collapsed waves-effect"
                            data-toggle="collapse"
                            :href="`#collapse${index}`"
                            aria-expanded="false"
                            :aria-controls="`collapse${index}`"
                            @click="closeSlidebar"
                        >
                            <i :class="`fa ${title.icon ? title.icon : 'fa fa-cog'}`"></i>
                            <span class="ml10">{{ title.title.ch }}</span>
                        </a>
                    </router-link>
                </div>
                <!-- Card body -->
                <!-- <div :id="`collapse${index}`" class="collapse" role="tabpanel" :aria-labelledby="`heading${index}`" data-parent="#accordionEx">
                    <ul class="card-body">
                        <li v-for="(child,index) in title.children" :key="index">
                            <router-link :to="{ name: child.name ? child.name : '' }">{{ child.title.ch }}</router-link>
                        </li>
                    </ul>
                </div>-->
            </div>
        </div>
    </div>
</template>
<script>
// import { systemMenu } from '@/assets/config';
import { closeSlidebar } from "@/assets/slidebars.scripts.js";

export default {
    name: "slidebar",
    props: ["role"],
    data() {
        return {
            // systemMenu: systemMenu
            menuData: []
        };
    },
    created() {
        setTimeout(() => {
            this.getMenu();
        }, 0);
    },
    methods: {
        closeSlidebar() {
            closeSlidebar();
        },
        getMenu() {
            this.menuData = JSON.parse(localStorage.User).sysPermMenu.menu;
        }
    }
};
</script>